<template>
  <div class="flex justify-center items-center">
    <svg class="transform -rotate-90 w-32 h-32">
      <circle
        :cx="circleConfig.c / 2.25"
        :cy="circleConfig.c / 2.25"
        :r="circleConfig.r / 2.25"
        :stroke-width="circleConfig.strokeWidth"
        fill="transparent"
        class="text-gray-700 stroke-brand-gray-250"
      />

      <circle
        :cx="circleConfig.c / 2.25"
        :cy="circleConfig.c / 2.25"
        :r="circleConfig.r / 2.25"
        :stroke-width="circleConfig.strokeWidth"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="circumference - (percentage / 100) * circumference"
        stroke="currentColor"
        fill="transparent"
        class="text-primary"
      />
    </svg>
    <span class="absolute text-3xl"> {{ percentage.toFixed(0) }}% </span>
  </div>
</template>

<script setup>
defineProps({
  percentage: {
    type: Number,
    default: () => 0
  }
})

const circumference = ((2 * 22) / 7) * 54

const circleConfig = {
  c: 145,
  r: 120,
  strokeWidth: 12
}
</script>

<style lang="scss" scoped>
.stat-circle {
  circle.bg {
    fill: none;
    stroke-width: 2;
  }
  circle.progress {
    fill: none;
    stroke-width: 2;
    stroke-dasharray: 51 51;
    stroke-dashoffset: 80;
    stroke-linecap: round;
  }
  text {
    font-size: 3px;
    text-anchor: middle;
    fill: #555;
  }
}
</style>
